module.exports = __webpack_public_path__ + "img/oops-penguin.ba46d691.svg";